import React from 'react';
import { Drawer as DrawerPrimitive } from 'vaul';
import { useTheme } from '../../contexts/ThemeContext';
import { spacing, borderRadius } from '../../constants/designTokens';

/**
 * Drawer component built on top of Vaul
 */
export const Drawer = ({ children, ...props }) => {
  return <DrawerPrimitive.Root {...props}>{children}</DrawerPrimitive.Root>;
};

export const DrawerTrigger = DrawerPrimitive.Trigger;

export const DrawerPortal = DrawerPrimitive.Portal;

export const DrawerClose = DrawerPrimitive.Close;

export const DrawerOverlay = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <DrawerPrimitive.Overlay
      ref={ref}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 50,
        background: 'rgba(0, 0, 0, 0.5)',
        ...props.style
      }}
      {...props}
    />
  );
});
DrawerOverlay.displayName = 'DrawerOverlay';

export const DrawerContent = React.forwardRef(({ children, ...props }, ref) => {
  const { colors } = useTheme();

  return (
    <DrawerPortal>
      <DrawerOverlay />
      <DrawerPrimitive.Content
        ref={ref}
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 50,
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '85vh',
          borderTopLeftRadius: borderRadius.xl,
          borderTopRightRadius: borderRadius.xl,
          background: colors.backgroundPanel,
          border: `1px solid ${colors.border}`,
          borderBottom: 'none',
          ...props.style
        }}
        {...props}
      >
        {/* Drawer handle */}
        <div
          style={{
            width: '48px',
            height: '4px',
            borderRadius: '999px',
            background: colors.border,
            margin: `${spacing.md} auto ${spacing.sm}`,
            flexShrink: 0
          }}
        />
        {children}
      </DrawerPrimitive.Content>
    </DrawerPortal>
  );
});
DrawerContent.displayName = 'DrawerContent';

export const DrawerHeader = ({ children, ...props }) => {
  return (
    <div
      style={{
        padding: `${spacing.md} ${spacing.xl}`,
        paddingTop: 0,
        flexShrink: 0,
        ...props.style
      }}
      {...props}
    >
      {children}
    </div>
  );
};

export const DrawerTitle = ({ children, ...props }) => {
  const { colors } = useTheme();

  return (
    <h2
      style={{
        margin: 0,
        fontSize: '1.25rem',
        fontWeight: 600,
        color: colors.foreground,
        ...props.style
      }}
      {...props}
    >
      {children}
    </h2>
  );
};

export const DrawerDescription = ({ children, ...props }) => {
  return (
    <div
      style={{
        padding: `0 ${spacing.xl}`,
        paddingBottom: spacing.xl,
        overflowY: 'auto',
        flex: 1,
        minHeight: 0,
        ...props.style
      }}
      {...props}
    >
      {children}
    </div>
  );
};

export const DrawerActions = ({ children, className, ...props }) => {
  const { colors } = useTheme();

  return (
    <div
      style={{
        padding: spacing.xl,
        borderTop: `1px solid ${colors.border}`,
        display: 'flex',
        gap: spacing.sm,
        flexShrink: 0,
        ...props.style
      }}
      className={className}
      {...props}
    >
      {children}
    </div>
  );
};
